import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import { SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES } from "@faire/web-api/indigofair/settings/SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES";
export function getSettingShipWithFaireEnabledCountries() {
  return getSettingValueWithoutAssignment(SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES, [ISO3166Alpha3.USA]);
}